import { render, staticRenderFns } from "./Demandeur.vue?vue&type=template&id=be5aae86&scoped=true&"
import script from "./Demandeur.vue?vue&type=script&lang=js&"
export * from "./Demandeur.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be5aae86",
  null
  
)

export default component.exports